import React, { useEffect, useState } from 'react';
import { ButtonList, LanguageSelector, StatusBar } from "../../Components";
import { GlobalMenu, SystemMenu } from "../";
import { colors, fonts, frames, glyphs, icons, useMediaQuery } from "../../Styles";
import { Outlet, useLocation } from "react-router-dom";
import LogoDisplay from "../../Components/logoDisplay";
import { ButtonTypes, ListStyle_Types } from '../../Definitions';
import StatusList from '../../Components/statusList';

// #region | CloudpanelLayoutDesktop
const CloudpanelLayoutDesktop = () => {
  return (
    <frames.CloudPanel>
      <LogoDisplay overrides={{ gridArea: "logoDisplay" }} ChooseSite={true}/>
      <GlobalMenu overrides={{ gridArea: "globalMenu" }}/>
      <SystemMenu overrides={{ gridArea: "systemMenu" }} />
      <StatusBar overrides={{ gridArea: "statusBar" }} />
      <frames.LanguageSelector>
        <LanguageSelector
          overrides={{
            isPrimaryComponent: true,
          }} 
        />
      </frames.LanguageSelector> 
      <div style={{ gridArea: "page_outer", overflow: "hidden"}}>
        <Outlet /> 
      </div>
    </frames.CloudPanel>
  );
};
// #endregion
// ---------------------------------

// #region | CloudpanelLayoutMobile
const CloudpanelLayoutMobile = () => {
  const location = useLocation();

  const groupMenu2columns = useMediaQuery(`(max-width: 454px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)

  const [showComponents, setShowComponents] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [showGlobalMenu, setShowGlobalMenu] = useState(true);
  const [showSystemMenu, setShowSystemMenu] = useState(false);
  const [showStatusBar, setShowStatusBar] = useState(false);

  const MenuOptions = {
    GLOBAL_MENU: 0,
    SYSTEM_MENU: 1,
    SYSTEM_STATUS: 2,
  };

  const _lineStyle: React.CSSProperties = {   
    width: "100%",
    height: "3px",
    backgroundColor: colors.greyLightTertiary,
    transition: "all 0.3s ease",
    borderRadius: "10px"
  }

  const MenuIcon = (
    <div style={{width: "25px", height: "17px", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
      <div style={{..._lineStyle, transform: menuOpen? "rotate(45deg) translate(5px, 5px)" : "rotate(0deg) translate(0px, 0px)" }}/>
      <div style={{..._lineStyle, opacity: menuOpen? "0" : "1"}}/>
      <div style={{..._lineStyle, transform: menuOpen? "rotate(-45deg) translate(5px, -5px)" : "rotate(0deg) translate(0px, 0px)"}}/>
    </div>
  )

  const handleButtonClick = (menu: number) => {
    switch (menu) {
      case MenuOptions.GLOBAL_MENU:
        setShowGlobalMenu(true);
        setShowSystemMenu(false);
        setShowStatusBar(false);
        break;
      case MenuOptions.SYSTEM_MENU:
        setShowSystemMenu(true);
        setShowGlobalMenu(false);
        setShowStatusBar(false);
        break;
      case MenuOptions.SYSTEM_STATUS:
        setShowStatusBar(true);
        setShowGlobalMenu(false);
        setShowSystemMenu(false);
        break;
      default:
        break;
    }
  };

  const _style: React.CSSProperties = {
    gridArea: "2/1/3/2",
    display: "flex",
    alignItems: "end",
    // overflowY: "scroll",
    overflow: "hidden",
    maxHeight: "100%"
  };

  // To show or not to show mobile menu
  const toggleComponents = () => {
    setShowComponents(!showComponents);
    setMenuOpen(!menuOpen);
  };

  // Reset showComponents to false when the location changes
  useEffect(() => {
    setShowComponents(false);
    setMenuOpen(false);
  }, [location]);

  return ( <>
      <button onClick={toggleComponents} style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent:"center", 
        flexDirection: "column",
        position: "absolute", 
        bottom: "10px", 
        left: "0px", 
        width:"60px", 
        height:"60px", 
        backgroundColor: colors.blueDarkPrimary+"cc", 
        borderStyle: "solid",
        borderColor: colors.blueDarkPrimary,
        borderWidth: "2px 2px 2px 0px",
        borderRadius: "0 10px 10px 0", 
        cursor: "pointer", 
        zIndex: menuOpen? "9999999" : "999",
        gap: "5px",
        backdropFilter: "blur(2px)"
      }} >
        {MenuIcon}
        <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>Menu</p>
      </button>

    <frames.CloudPanel>
      {showComponents && ( <>
        <div onClick={toggleComponents} style={{ backgroundColor: "black", opacity: "0.5", position: "absolute", top: 0, left: 0, bottom: 0, right: 0, zIndex: "99999"}}/>
        
        <div style={{display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "150px 1fr auto", rowGap: "10px", position: "absolute", top: 20, left: 20, bottom: 20, right: 20, zIndex: "999999", inset: "10px"}}>
          <div style={{gridArea: "1/1/2/2"}}><LogoDisplay ChooseSite={true}/></div>
          <div style={{gridArea: "2/1/3/2", display: "flex", alignItems: "end"}}>{showGlobalMenu && <GlobalMenu/>}</div>
          <div style={_style}>{showSystemMenu && <SystemMenu/>}</div>
          <div style={_style}>{showStatusBar && <StatusList/>}</div>
          <div style={{gridArea: "3/1/4/2"}}>
            <div style={{width: "100%", height: "fit-content", maxWidth: "550px", padding: "7.5px", boxSizing: "border-box", backgroundColor: colors.greyDarkPrimary, borderRadius: "0px 0px 10px 10px", margin: "0px auto", display: "flex", justifyContent: "center"}}>
            <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px"}}>
              <ButtonList contents={["Global Menu", "System Menu", "Attentions", "Language"]}
                onClick={(menu) => handleButtonClick(menu)}
                buttonType={ButtonTypes.globalMenuButton}
                overrides={{
                  startEnhancerStyles: {width: "25px", height: "25px"},
                  hoverStyles: {backgroundColor: colors.greyDarkSecondary}
                }}
                hasActiveLoad={true}
                listOverrides={{
                  listStyle: ListStyle_Types.group
                }}
                startEnhancers={[
                  icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings
                ]}/>
              </div>
            </div>
          </div>
        </div>

      </> )}
      <div style={{ gridArea: "page_outer", overflow: "hidden"}}>
        <Outlet /> 
      </div>
    </frames.CloudPanel>
  </> );
};
// #endregion
// ---------------------------------

const CloudpanelLayout = () => {
  const mobile = useMediaQuery(`(max-width: 1000px)`);
  return ( <>
    {mobile ? <CloudpanelLayoutMobile/> : <CloudpanelLayoutDesktop/>}
  </> )
}

export default CloudpanelLayout
